import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { countryCodes } from '../../data/countries';

@Component({
  selector: 'app-mobile-input',
  templateUrl: './mobile-input.component.html',
  styleUrls: ['./mobile-input.component.scss']
})
export class MobileInputComponent implements OnInit {

  @Input() form: FormGroup;  // Parent form
  @Input() mobileControlName: string = 'Mobile';  // Dynamic control name for mobile number
  @Input() defaultMobileCode: string = '+974';  // Default value for Qatar
  @Input() label: string = 'Mobile Number';  // Custom label for the input
  @Input() labelClass: string = 'form-label';  // Default class for the label
  @Input() readonly: boolean = false;  // When true, input and country code select are not editable

  countryCodes = countryCodes;

  // Computed mobile code control name based on mobileControlName
  get mobileCodeControlName(): string {
    return this.mobileControlName + 'Code';
  }

  onInput(event: any) {
    const input = event.target as HTMLInputElement;
    const digitsOnly = input.value.replace(/[^0-9]/g, '');
    input.value = digitsOnly;
    this.form.get(this.mobileControlName)?.setValue(digitsOnly, { emitEvent: true });
  }

  

  ngOnInit(): void {
    // Ensure form and form controls are initialized
    if (this.form) {
      if (!this.form.get(this.mobileCodeControlName)) {
        this.form.addControl(this.mobileCodeControlName, new FormControl(this.defaultMobileCode, Validators.required));
      }
      if (!this.form.get(this.mobileControlName)) {
        this.form.addControl(this.mobileControlName, new FormControl('', Validators.required));
      }
    } else {
      console.error('Parent form is not initialized.');
    }
  }
}
